import MetaHead from '../components/MetaHead';

export default function CvPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-10">
      <MetaHead 
        title="CV - Din Privat Psykolog"
        description="Privat psykolog, 20 års erfaring, Klinisk psykolog i Syddanmark, Autoriseret psykolog med bred klinisk erfaring, Samtaleterapi med individuelle, samtaleterapi, parterapi, psykologhjælp,  "
        ogTitle="CV - Marie Aagaard Larsen - Din Privat Psykolog"
        ogDescription="Privat psykolog, 20 års erfaring, Klinisk psykolog i Syddanmark, Autoriseret psykolog med bred klinisk erfaring, Samtaleterapi med individuelle, samtaleterapi, parterapi, psykologhjælp,  "
        ogImage="https://assets.auxodev.dk/assets/9bc67d49-c1ad-4360-8231-e9811640bce9/61a0bb4f-47a8-4ecb-a747-8c6184fb1879_3bd59b5a.jpg"
      />

      {/* Header */}
      <div className="border-b border-[#E0D7C6] pb-8 space-y-3">
        <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#5f7365]">
          Curriculum Vitae (CV)
        </h1>
        <p className="text-base sm:text-lg text-[#3B4D42] max-w-3xl leading-relaxed">
          Klinisk psykolog cand. psych. aut. Marie Aagaard Larsen
        </p>
      </div>

      <div className="space-y-8 text-[#5f7365] text-sm sm:text-base leading-relaxed">
        
        {/* Intro-tekst: Resumé */}
        <section className="bg-[#FBF9F5] border border-[#E8E2D5] p-6 sm:p-8 space-y-4 shadow-xs">
          <div className="flex items-center gap-3 border-b border-[#E0D7C6] pb-3">
            <span className="w-2.5 h-2.5 rounded-full bg-[#C6A868]" aria-hidden="true" />
            <h2 className="font-serif text-2xl font-bold text-[#5f7365]">
              RESUMÉ
            </h2>
          </div>
          <div className="space-y-3 text-[#384A3F] leading-relaxed">
            <p>
              Jeg har over 20 års erfaring som psykolog inden for visitation, udredning, psykoedukation, krise-debreifings, supervision samt selvfølgelig behandlingsområdet. Og jeg har igennem alle år arbejdet intensivt med samtaleterapi med såvel børn, unge, voksne og dette i form af såvel individuel-, par-, familie- samt gruppeterapi. Desuden er jeg en meget brugt og erfaren <a href="http://www.humaneye.dk/" target="_blank" rel="noopener noreferrer" className="text-[#5f7365] font-semibold hover:underline">erhvervspsykolog</a>.
            </p>
            <p>
              Jeg har talent for at holde hovedet koldt og hjertet varmt i smertehåndteringssamtaler/krisesamtaler, og hurtigt være i stand til at skelne hvad der er person og hvad er krisereaktion. Og dernæst at time og dosere den rette indsats, så klienten i centrum føler sig set, mødt og forstået og støttet/udfordret passende fra gang til gang. Min behandlingsstil består af en vifte af psykologfaglige metoder og tilgange, men altid tilpasset den enkelte klients behov og ressourcer.
            </p>
          </div>
        </section>

        {/* CV Sektioner */}
        <div className="space-y-6">
          
          {/* Sektion: Resultater */}
          <div className="border border-[#EDE6D8] bg-white p-6 sm:p-8 space-y-4">
            <h2 className="font-serif text-2xl font-bold text-[#5f7365] pb-3 border-b border-[#EDE6D8]">
              RESULTATER
            </h2>
            <div className="space-y-3 text-[#384A3F] leading-relaxed">
              <p>
                Autoriseret af Psykolognævnet 2011 og automatisk overgået januar 2026 til ny autorisationsordning for psykologer med titlen: "Klinisk psykolog". Det er Styrelsen for Patientsikkerhed der har tilsynet med psykologer.
              </p>
              <p>
                Bred klinisk erfaring: Klinisk planlægning og udførelse af omkring 15.000 terapeutiske samtaler i egen klinik. Indenfor alle sygesikringens kategorier.
              </p>
              <p>
                Supervision af egen faggruppe og af andre faggrupper. Samt har haft psykologistuderende fra Aarhus Universitet i praktik i min klinik.
              </p>
            </div>
          </div>

          {/* Sektion: Personlige egenskaber */}
          <div className="border border-[#EDE6D8] bg-white p-6 sm:p-8 space-y-4">
            <h2 className="font-serif text-2xl font-bold text-[#5f7365] pb-3 border-b border-[#EDE6D8]">
              PERSONLIGE EGENSKABER
            </h2>
            <div className="space-y-3 text-[#384A3F] leading-relaxed">
              <ul className="space-y-2 list-disc pl-5">
                <li>Ambitiøs og ordentlig i forhold til opnåelse af behandlingsmålet</li>
                <li>Empatisk og god til at finde gode behandlingsveje i mødet med klienter</li>
                <li>Positiv og en seriøs samarbejdspartner</li>
                <li>En stærk kommunikator som er god til at sætte konkrete ord på komplekse tilstande og give let følgelige råd og vejledning.</li>
              </ul>
            </div>
          </div>

          {/* Sektion: Overblik – Arbejdspladser */}
          <div className="border border-[#EDE6D8] bg-white p-6 sm:p-8 space-y-4">
            <h2 className="font-serif text-2xl font-bold text-[#5f7365] pb-3 border-b border-[#EDE6D8]">
              OVERBLIK – ARBEJDSPLADSER
            </h2>
            <div className="space-y-4">
              <p className="text-xs text-[#52685B]">
                2009-2026: Driver og ejer egen selvstændig psykologvirksomhed. Har haft overenskomst med sygesikringen, men har opsagt denne ordning og er privatpraktiserende psykolog.
              </p>
              <p className="text-xs italic text-[#52685B]">
                Nedenstående er deltidsansættelser/konsulentkontrakter, som jeg har kombineret med min egen virksomhed:
              </p>

              <div className="space-y-3 text-xs sm:text-sm text-[#384A3F]">
                <div className="py-2 border-b border-[#EDE6D8]">
                  <strong>2020-2021:</strong> Psykolog på Center for Voldtægtsofre på Kolding Sygehus
                </div>
                <div className="py-2 border-b border-[#EDE6D8]">
                  <strong>2019-:</strong> Krisepsykolog og sygesikringspsykolog via SOS-International, Precsriba, PrimaCare, Dansk Sundhedssikring, Gjensidige og flere.
                </div>
                <div className="py-2 border-b border-[#EDE6D8]">
                  <strong>2016-2018:</strong> Familie afdelingen Vejen kommune som supervisor for de ansatte psykologer.
                </div>
                <div className="py-2 border-b border-[#EDE6D8]">
                  <strong>2015-2016:</strong> Udvikler af dokumentationsplatform for STU Haderslev.
                </div>
                <div className="py-2 border-b border-[#EDE6D8]">
                  <strong>2013:</strong> Gruppeterapeut for børn og unge i TUBA Kolding (100 timers frivilligt terapeut arbejde)
                </div>
                <div className="py-2 border-b border-[#EDE6D8]">
                  <strong>2011-2012:</strong> Konsulentarbejde i tværfagligt team for Syddansk Smerteklinik i Haderslev. Smertepsykologi.
                </div>
                <div className="py-2 border-b border-[#EDE6D8]">
                  <strong>2008-2016:</strong> Supervisor for andre faggrupper på STU Haderslev.
                </div>
                <div className="py-2 border-b border-[#EDE6D8]">
                  <strong>2006-2008:</strong> Ansættelse i Vejen Kommune: PPR (Pædagogisk og psykologisk rådgivning) og i Familieafdelingen.
                </div>
                <div className="py-2 border-b border-[#EDE6D8]">
                  <strong>2005-2006:</strong> Ansættelse i mine forældres psykologvirksomhed.
                </div>
              </div>
            </div>
          </div>

          {/* Sektion: Uddannelse og kurser */}
          <div className="border border-[#EDE6D8] bg-white p-6 sm:p-8 space-y-4">
            <h2 className="font-serif text-2xl font-bold text-[#5f7365] pb-3 border-b border-[#EDE6D8]">
              UDDANNELSE OG KURSER
            </h2>
            <div className="space-y-4">
                {/* Desktop: Parvise rækker så linjerne flugter 100% vandret mellem venstre og højre kolonne */}
                <div className="hidden md:block text-xs sm:text-sm text-[#384A3F]">
                  {/* Række 1 */}
                  <div className="grid grid-cols-2 gap-x-10 items-stretch">
                    <div className="py-2.5 border-b border-[#EDE6D8] flex items-center">
                      <div><strong>2026:</strong> Selvmordsrisikovurdering og procedurer for selvmordstruede klienter, chefpsykolog Nina Lange Forsberg</div>
                    </div>
                    <div className="py-2.5 border-b border-[#EDE6D8] flex items-center">
                      <div><strong>2020:</strong> Designtænkning fra Designskolen i Kolding</div>
                    </div>
                  </div>

                  {/* Række 2 */}
                  <div className="grid grid-cols-2 gap-x-10 items-stretch">
                    <div className="py-2.5 border-b border-[#EDE6D8] flex items-center">
                      <div><strong>2025:</strong> ACT Acceptance and Commitment Therapy: Værdiskabende samtaler ved Ditte Hoffmann Frydendal.</div>
                    </div>
                    <div className="py-2.5 border-b border-[#EDE6D8] flex items-center">
                      <div><strong>2018:</strong> Grundlæggende ledelse fra IBC Kolding</div>
                    </div>
                  </div>

                  {/* Række 3 */}
                  <div className="grid grid-cols-2 gap-x-10 items-stretch">
                    <div className="py-2.5 border-b border-[#EDE6D8] flex items-center">
                      <div><strong>2025:</strong> Forebyggelse af omsorgstræthed med embodiment og nye færdigheder i relationsarbejdet ved psykoterapeut Maja Pålsson</div>
                    </div>
                    <div className="py-2.5 border-b border-[#EDE6D8] flex items-center">
                      <div><strong>2017:</strong> Mentaliseringsbaseret terapi ved Center For Mentalisering i Aarhus</div>
                    </div>
                  </div>

                  {/* Række 4 */}
                  <div className="grid grid-cols-2 gap-x-10 items-stretch">
                    <div className="py-2.5 border-b border-[#EDE6D8] flex items-center">
                      <div><strong>2025:</strong> Det arbejdsmarkedsrettede perspektiv (herunder om afholdelse af trepartsmøder samt at lave fastholdelsesplaner)</div>
                    </div>
                    <div className="py-2.5 border-b border-[#EDE6D8] flex items-center">
                      <div><strong>2014:</strong> Mindfulness i arbejdet som psykolog - ved Psykolog Camilla Holmgaard Johansen</div>
                    </div>
                  </div>

                  {/* Række 5 */}
                  <div className="grid grid-cols-2 gap-x-10 items-stretch">
                    <div className="py-2.5 border-b border-[#EDE6D8] flex items-center">
                      <div><strong>2025:</strong> Shaolin Masterstudent program</div>
                    </div>
                    <div className="py-2.5 border-b border-[#EDE6D8] flex items-center font-semibold text-[#5f7365]">
                      <div><strong>2011:</strong> Autoriseret af Psykolognævnet</div>
                    </div>
                  </div>

                  {/* Række 6 */}
                  <div className="grid grid-cols-2 gap-x-10 items-stretch">
                    <div className="py-2.5 border-b border-[#EDE6D8] flex items-center">
                      <div><strong>2023:</strong> Åndedrætsterapi: Bevidst vejrtrækning ved Lotte Maggie Mogensen</div>
                    </div>
                    <div className="py-2.5 border-b border-[#EDE6D8] flex items-center">
                      <div><strong>2010:</strong> Kursus i Det levende parforhold - Relations Fokuseret Parterapi</div>
                    </div>
                  </div>

                  {/* Række 7 */}
                  <div className="grid grid-cols-2 gap-x-10 items-stretch">
                    <div className="py-2.5 border-b border-[#EDE6D8] flex items-center">
                      <div><strong>2022:</strong> Tab og traumer ved Mai-Britt Guldin, cand.psych.aut.Professor, Specialist i psykoterapi og supervisor.</div>
                    </div>
                    <div className="py-2.5 border-b border-[#EDE6D8] flex items-center">
                      <div><strong>2010:</strong> Kursus i Supervision af andre faggrupper ved Benedicte Schilling</div>
                    </div>
                  </div>

                  {/* Række 8 */}
                  <div className="grid grid-cols-2 gap-x-10 items-stretch">
                    <div className="py-2.5 border-b border-[#EDE6D8] flex items-center">
                      <div><strong>2021:</strong> Førstehjælpskursus: Førstehjælp ved hjertestop, hjerte-lunge-redning (HLR) med og uden hjertestarter (AED) – 4 timers moduluddannelse ved Dansk Førstehjælpsråd og Dansk Folkehjælp. (Aktiv hjerteløber i perioder).</div>
                    </div>
                    <div className="py-2.5 border-b border-[#EDE6D8] flex items-center font-semibold text-[#5f7365]">
                      <div><strong>2005:</strong> Kandidat eksamen i psykologi (cand. psych.) fra Københavns Universitet</div>
                    </div>
                  </div>

                  {/* Række 9 */}
                  <div className="grid grid-cols-2 gap-x-10 items-stretch">
                    <div className="py-2.5 border-b border-[#EDE6D8] flex items-center">
                      <div><strong>2020-2021:</strong> EMDR-terapi-uddannelse del 1, København</div>
                    </div>
                    <div className="py-2.5 border-b border-[#EDE6D8] flex items-center">
                      <div><strong>2000:</strong> Grunduddannelsen i filosofi fra Københavns Universitet</div>
                    </div>
                  </div>
                </div>

                {/* Mobil: Enkel fortløbende liste (2026 -> 2000) */}
                <div className="md:hidden text-xs sm:text-sm text-[#384A3F]">
                  <div className="py-2 border-b border-[#EDE6D8]">
                    <strong>2026:</strong> Selvmordsrisikovurdering og procedurer for selvmordstruede klienter, chefpsykolog Nina Lange Forsberg
                  </div>
                  <div className="py-2 border-b border-[#EDE6D8]">
                    <strong>2025:</strong> ACT Acceptance and Commitment Therapy: Værdiskabende samtaler ved Ditte Hoffmann Frydendal.
                  </div>
                  <div className="py-2 border-b border-[#EDE6D8]">
                    <strong>2025:</strong> Forebyggelse af omsorgstræthed med embodiment og nye færdigheder i relationsarbejdet ved psykoterapeut Maja Pålsson
                  </div>
                  <div className="py-2 border-b border-[#EDE6D8]">
                    <strong>2025:</strong> Det arbejdsmarkedsrettede perspektiv (herunder om afholdelse af trepartsmøder samt at lave fastholdelsesplaner)
                  </div>
                  <div className="py-2 border-b border-[#EDE6D8]">
                    <strong>2025:</strong> Shaolin Masterstudent program
                  </div>
                  <div className="py-2 border-b border-[#EDE6D8]">
                    <strong>2023:</strong> Åndedrætsterapi: Bevidst vejrtrækning ved Lotte Maggie Mogensen
                  </div>
                  <div className="py-2 border-b border-[#EDE6D8]">
                    <strong>2022:</strong> Tab og traumer ved Mai-Britt Guldin, cand.psych.aut.Professor, Specialist i psykoterapi og supervisor.
                  </div>
                  <div className="py-2 border-b border-[#EDE6D8]">
                    <strong>2021:</strong> Førstehjælpskursus: Førstehjælp ved hjertestop, hjerte-lunge-redning (HLR) med og uden hjertestarter (AED) – 4 timers moduluddannelse ved Dansk Førstehjælpsråd og Dansk Folkehjælp. (Aktiv hjerteløber i perioder).
                  </div>
                  <div className="py-2 border-b border-[#EDE6D8]">
                    <strong>2020-2021:</strong> EMDR-terapi-uddannelse del 1, København
                  </div>
                  <div className="py-2 border-b border-[#EDE6D8]">
                    <strong>2020:</strong> Designtænkning fra Designskolen i Kolding
                  </div>
                  <div className="py-2 border-b border-[#EDE6D8]">
                    <strong>2018:</strong> Grundlæggende ledelse fra IBC Kolding
                  </div>
                  <div className="py-2 border-b border-[#EDE6D8]">
                    <strong>2017:</strong> Mentaliseringsbaseret terapi ved Center For Mentalisering i Aarhus
                  </div>
                  <div className="py-2 border-b border-[#EDE6D8]">
                    <strong>2014:</strong> Mindfulness i arbejdet som psykolog - ved Psykolog Camilla Holmgaard Johansen
                  </div>
                  <div className="py-2 border-b border-[#EDE6D8] font-semibold text-[#5f7365]">
                    <strong>2011:</strong> Autoriseret af Psykolognævnet
                  </div>
                  <div className="py-2 border-b border-[#EDE6D8]">
                    <strong>2010:</strong> Kursus i Det levende parforhold - Relations Fokuseret Parterapi
                  </div>
                  <div className="py-2 border-b border-[#EDE6D8]">
                    <strong>2010:</strong> Kursus i Supervision af andre faggrupper ved Benedicte Schilling
                  </div>
                  <div className="py-2 border-b border-[#EDE6D8] font-semibold text-[#5f7365]">
                    <strong>2005:</strong> Kandidat eksamen i psykologi (cand. psych.) fra Københavns Universitet
                  </div>
                  <div className="py-2 border-b border-[#EDE6D8]">
                    <strong>2000:</strong> Grunduddannelsen i filosofi fra Københavns Universitet
                  </div>
                </div>
              </div>
            </div>

        </div>

      </div>
    </div>
  );
}
